import {
  keyArgsForPagination,
  mergeAccessibleUserForPagination,
} from "./modules/utils";

const BehaviourIncidentTypePolicy = {
  BehaviourIncident: {
    fields: {
      accessibleUsers: {
        keyArgs: args => {
          if (args) {
            const filters = args["input"];
            const keys = keyArgsForPagination(filters);
            return ["input", keys];
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeAccessibleUserForPagination({
              existing,
              incoming,
              readField,
              filters: args["input"],
            });
          }
          return incoming;
        },
      },
    },
  },
};

export default BehaviourIncidentTypePolicy;
